import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { useParams, usePathname } from 'next/navigation';
import { useForm, SubmitHandler } from 'react-hook-form';
import LoadingButton from '../LoadingButton';
import CommentCard from './CommentCard';
import { Modal } from '@/ui/kit/components/modal';
import { TextField } from '@/ui/kit/components/textfield';
import { useAddComment } from '@/api/hooks/useAddComment';
import { useSession } from '@/utils/auth/useSession';
import { MetaDataParams } from '@/types/models';
import { QUERY_KEYS } from '@/utils/constants/query-keys';
export type TCommentForm = {
  content: string;
};
const AddComment = () => {
  const params = useParams<MetaDataParams>();
  const id = params.slug?.[0] || params.id;
  const pathname = usePathname();
  const {
    user: userData
  } = useSession();
  const [isOpen, setIsOpen] = useState(false);
  const {
    mutate,
    isSuccess,
    isPending,
    reset
  } = useAddComment();
  const methods = useForm<TCommentForm>({
    mode: 'onSubmit'
  });
  const {
    register,
    handleSubmit,
    getValues,
    resetField,
    formState: {
      isValid,
      errors
    }
  } = methods;
  const handleAddComment = (data: TCommentForm) => {
    mutate({
      content: data.content as string,
      planId: id as string
    }, {});
  };
  const onSubmit: SubmitHandler<TCommentForm> = (data: TCommentForm) => !isValid ? undefined : handleAddComment(data);
  return <>
      <Button variant='outlined' color='primary' size='medium' onClick={() => setIsOpen(true)} data-sentry-element="Button" data-sentry-source-file="AddComment.tsx">
        ثبت پرسش جدید
      </Button>
      <Modal title='ثبت پرسش جدید' open={isOpen} onClose={() => {
      reset();
      resetField('content');
      setIsOpen(false);
    }} data-sentry-element="Modal" data-sentry-source-file="AddComment.tsx">
        <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: 'var(--spacing_m)',
        maxWidth: '456px',
        width: '100%',
        margin: 'auto',
        p: 'var(--spacing_l)'
      }} data-sentry-element="Box" data-sentry-source-file="AddComment.tsx">
          {!userData ? <>
              <Typography variant='bodyRegular__Wallfund' color='text.text'>
                برای ثبت پرسش جدید، وارد حساب کاربری خود شوید. اگر تاکنون حساب
                کاربری نداشته‌اید، می‌توانید ثبت‌نام کنید.
              </Typography>
              <Box display='flex'>
                <Button variant='contained' color='primary' size='large' sx={{
              flex: 1,
              height: '48px',
              borderColor: 'primary'
            }} href={`/login?${QUERY_KEYS.redirectTo}=${pathname}`}>
                  ورود / ثبت‌نام{' '}
                </Button>
              </Box>
            </> : <Box component={'form'} sx={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: 'var(--spacing_m_nudge)'
        }} onSubmit={handleSubmit(onSubmit)}>
              {!isSuccess && <Box rowGap={2} sx={{
            display: 'flex',
            flexDirection: 'column',
            width: {
              md: '392px',
              xs: 'initial'
            },
            gap: 'var(--spacing_m)'
          }}>
                  <Box display='flex' sx={{
              gap: 'var(--spacing_m)'
            }}>
                    <Typography variant='bodyRegular__Wallfund' color='text.text2'>
                      نام و نام‌خانوادگی کاربر:
                    </Typography>
                    <Typography variant='bodyStrong__Wallfund'>
                      {userData?.legalType === 'legal' ? userData.companyName : (userData?.firstName || '') + ' ' + (userData?.lastName || '')}
                    </Typography>
                  </Box>
                  <TextField sx={{
              margin: 0
            }} size='large' label='متن پرسش' placeholder='متن پرسش خود را وارد کنید' multiline={true} rows={4} {...register('content', {
              required: 'لطفا متن را وارد کنید'
            })} error={!!errors?.content?.message} helperText={errors?.content?.message} />
                </Box>}
              {isSuccess && <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            p: 'var(--spacing_m)',
            border: '1px solid',
            borderColor: 'stroke.stroke2',
            borderRadius: 'var(--corner_radius_xl)'
          }}>
                  <CommentCard {...{
              id: 0,
              authorName: userData.firstName,
              authorLastName: userData.lastName,
              replyTo: null,
              content: getValues('content'),
              createdAt: null,
              replies: []
            }} isAdmin={false} />
                </Box>}

              {isSuccess && <Typography variant='bodyRegular__Wallfund' color='text.text'>
                  ثبت پرسش شما با موفقیت انجام شد و پس از بررسی کارشناسان ما،
                  منتشر و پاسخ داده خواهد شد.
                </Typography>}
              <Box sx={{
            display: 'flex',
            gap: 'var(--spacing_s)'
          }}>
                <Button variant={isSuccess ? 'contained' : 'outlined'} color='primary' size='large' sx={{
              flex: 1,
              height: '48px'
            }} onClick={() => {
              if (isSuccess) {
                reset();
                resetField('content');
              }
              setIsOpen(false);
            }}>
                  {isSuccess ? 'متوجه شدم' : 'انصراف'}
                </Button>
                {!isSuccess && <LoadingButton variant='contained' color='primary' size='large' sx={{
              flex: 1,
              height: '48px'
            }} type='submit' loading={isPending}>
                    ثبت پرسش
                  </LoadingButton>}
              </Box>
            </Box>}
        </Box>
      </Modal>
    </>;
};
export default AddComment;